import React, { useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import DateSelector from './DateSelector';
import PartySizeSelector from './PartySizeSelector';
import TimePicker from './TimePicker';

import './Selector.scss';

const Divider = ({ parent }) => (
  <div
    className={cx('Selector__divider', `Selector__divider--${parent}`)}
    aria-hidden="true"
    tabIndex={-1}
  />
);

Divider.propTypes = {
  parent: PropTypes.string.isRequired,
};

const Selector = (props) => {
  const {
    date,
    time,
    onPartySizeChange,
    onPartySizeClick,
    onTimeChange,
    onTimeClick,
    quantitySelected,
    toggleCalendar,
    calendarExpanded,
    setCalendarSticky,
    showTimeFilter,
    timeOptions,
  } = props;

  const quantity = String(quantitySelected || 2);
  const selectorRef = useRef(null);

  const [isSticky, setSticky] = useState(false);

  const getOffsetTop = function (element) {
    if (!element) return 0;
    return getOffsetTop(element.offsetParent) + element.offsetTop;
  };

  const onScroll = () => {
    if (selectorRef?.current) {
      const offsetTop = getOffsetTop(selectorRef.current);
      const { scrollY } = window;

      // Accounting for the top nav
      if ((offsetTop - 85) <= Math.round(scrollY)) { // sometimes window.scrollY reports decimal numbers
        if (!isSticky) {
          setSticky(true);
          setCalendarSticky(true);
        }
      } else if (isSticky) {
        setSticky(false);
        setCalendarSticky(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [isSticky]);

  return (
    <div
      className={cx('Selector', {
        Selector__sticky: isSticky,
      })}
      ref={selectorRef}
    >
      <PartySizeSelector
        onClick={onPartySizeClick}
        onChange={onPartySizeChange}
        quantitySelected={quantity}
        showChevron={false}
      />

      <DateSelector
        date={date}
        onClick={toggleCalendar}
        expanded={calendarExpanded}
      />
      {showTimeFilter && (
        <>
          <TimePicker
            dateSelected={date}
            onClick={onTimeClick}
            onChange={onTimeChange}
            timeSelected={time}
            timeOptions={timeOptions}
          />
          <Divider parent="time" />
        </>
      )}
      <Divider parent="date" />
    </div>
  );
};

Selector.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  onPartySizeChange: PropTypes.func.isRequired,
  onPartySizeClick: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  onTimeClick: PropTypes.func.isRequired,
  toggleCalendar: PropTypes.func.isRequired,
  quantitySelected: PropTypes.number,
  calendarExpanded: PropTypes.bool.isRequired,
  setCalendarSticky: PropTypes.func,
  showTimeFilter: PropTypes.bool.isRequired,
  timeOptions: PropTypes.shape({}),
};

Selector.defaultProps = {
  quantitySelected: 2,
  setCalendarSticky: () => {},
  timeOptions: null,
};

Selector.displayName = 'Selector';
export default Selector;
